export default {
  name: "articlesFilterSection",
  async created() {
    // await this.$loadScript("./vendor/noui/nouislider.min.js");
    // var filterBar = document.getElementById("filter-bar");
    // noUiSlider.create(filterBar, {
    //   start: [10, 1000],
    //   connect: true,
    //   range: {
    //     min: 10,
    //     max: 1000,
    //   },
    // });

    // var skipValues = [
    //   document.getElementById("value-lower"),
    //   document.getElementById("value-upper"),
    // ];

    // filterBar.noUiSlider.on("update", function(values, handle) {
    //   skipValues[handle].innerHTML = Math.round(values[handle]);
    // });

  }
};
